import React from "react";
import Navbar from "./components/navbar";
import Copyright from "./components/copyright";
import Footer from "./components/footer";
import Sambutan from "./components/sambutan";
import { Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Nav } from "react-bootstrap";
import Hero from "./pages/hero";
import TentangKami from "./pages/tentangKami";
import Agenda from "./pages/agenda";
import Kabar from "./pages/kabar";
import Ekstra from "./pages/ekstra";
import Testimoni from "./pages/testimoni";
import Sosmed from "./pages/sosmed";
import DetailTesti from "./components/detailTesti";
import Sidebar from "./components/sidebar";
import Berita from "./components/berita";

AOS.init();

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<MainContent />} />
        <Route path="/detailTesti/:id" element={<DetailTestiWithFooter />} />
        <Route path="/sambutan" element={<SambutanWithoutNavbar />} />
        <Route path="/sidebar" element={<Sidebar />} />
        <Route path="/berita" element={<Berita />} />
      </Routes>
    </div>
  );
}

function MainContent() {
  return (
    <>
      <Navbar />
      <Hero />
      <TentangKami />
      <Agenda />
      <Kabar />
      <Ekstra />
      <Testimoni />
      <Sosmed />
      <Footer />
      <Copyright />
    </>
  );
}

function DetailTestiWithFooter() {
  return (
    <>
      {/* <Navbar /> */}
      <DetailTesti />
      <Footer />
      <Copyright />
    </>
  );
}

function SambutanWithoutNavbar() {
  return (
    <>
      <Sambutan />
      {/* <Footer /> */}
      {/* <Copyright /> */}
    </>
  );
}

export default App;
